import { Typography } from '@mui/material';
import { Auth, Hub } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { LogOutIcon } from '../assets/LogOutIcon';
import { clearUserData } from '../redux/actions/userManagementActions';
import store from '../redux/store';

const LogOut = ({ handleClose }) => {
  const history = useHistory();
  const { t } = useTranslation('global');

  const [user, setUser] = useState(null);
  const closeMethod = handleClose;
  useEffect(() => {
    Hub.listen('auth', ({ payload: { event } }) => {
      switch (event) {
        case 'cognitoHostedUI':
          getUser().then(userData => setUser(userData));
          break;
        case 'signOut':
          store.dispatch(clearUserData());
          setUser(null);
          break;
        default:
      }
    });

    getUser().then(userData => setUser(userData));
  }, []);

  const getUser = () =>
    Auth.currentAuthenticatedUser().then(userData => userData);

  const handleClick = async () => {
    closeMethod && closeMethod();
    history.push('/');
    await Auth.signOut();
  };
  return (
    <>
      {user ? (
        <>
          <LogOutIcon onClick={handleClick} />
          <Typography data-test="logout-menu-item" onClick={handleClick}>
            {t('menuAvatar.menu.logOut')}
          </Typography>
        </>
      ) : null}
    </>
  );
};

export default LogOut;
